/* import __COLOCATED_TEMPLATE__ from './bounce.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

export default class PlayQueueBounceComponent extends Component {
  @service currentlyPlaying;

  @action
  removeBounce(event) {
    console.log('PQ::B removeBounce', event);
    event.preventDefault();
    if (this.args.removeBounce) {
      this.args.removeBounce(this.args.bounce);
    } else {
      this.currentlyPlaying.removeBounce(this.args.bounce);
    }
  }
}
